import Text from '@ui/text/text/text';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';

interface TextFieldProps {
  label?: string;
  ariaLabel?: string;
  value: string;
  onChange: (value: string) => void;
  // fires once typing pauses, for an update too expensive to run on every keystroke
  onDebounce?: (value: string) => void;
  debounceTime?: number;
  placeholder?: string;
  helperText?: string;
  valid?: boolean;
}

// shared plain-text field (label + bordered pill input), matching NumberField's look and feel
export default function TextField({
  label,
  ariaLabel,
  value,
  onChange,
  onDebounce,
  debounceTime,
  placeholder,
  helperText,
  valid = true,
}: TextFieldProps) {
  return (
    <div>
      <InputWithOverlay
        jsxLabel={
          label
            ? () => (
                <Text className="L2 padding-l-16 margin-b-2" design="GlobalIcoText3">
                  {label}
                </Text>
              )
            : undefined
        }
        inputHeight="32px"
        onDebounce={onDebounce}
        debounceTime={debounceTime}
        inputProps={{
          type: 'text',
          value,
          placeholder,
          onChange: (e) => onChange(e.target.value),
          'aria-label': label ? undefined : ariaLabel,
        }}
        status={valid ? 'default' : 'error'}
      />
      {helperText && (
        <Text className="C2 padding-l-16 margin-t-4" color="var(--global-ico-text-3)">
          {helperText}
        </Text>
      )}
    </div>
  );
}
